import React from "react";
import { BellRing, ChevronRight, Palette, SlidersHorizontal } from "lucide-react";
import { useTranslation } from "react-i18next";
import { isSimpleMode } from "../../utils/appMode";
import { isDarkTheme } from "../../utils/themeMode";
import { SETTINGS_PAGES } from "./settingsPages";

const PUSH_STATUS_KEYS = {
  active: ["settings_push_status_active", "Active on this device"],
  disabled: ["settings_push_status_disabled", "Disabled"],
  "not-configured": ["settings_push_status_not_configured", "Not configured"],
};

export default function SettingsHub({ appMode, themeMode, pushStatus, onNavigate }) {
  const { t } = useTranslation();
  const [pushStatusKey, pushStatusFallback] =
    PUSH_STATUS_KEYS[pushStatus] || PUSH_STATUS_KEYS["not-configured"];
  const cards = [
    {
      page: SETTINGS_PAGES.APP_MODE,
      Icon: SlidersHorizontal,
      title: t("settings_hub_app_mode_title", { defaultValue: "App mode" }),
      description: t("settings_hub_app_mode_description", {
        defaultValue: "Choose how much information and how many features are shown throughout the app.",
      }),
      status: isSimpleMode(appMode)
        ? t("simple_mode", { defaultValue: "Simple mode" })
        : t("full_mode", { defaultValue: "Full mode" }),
    },
    {
      page: SETTINGS_PAGES.APPEARANCE,
      Icon: Palette,
      title: t("settings_appearance", { defaultValue: "Appearance" }),
      description: t("settings_hub_appearance_description", {
        defaultValue: "Choose how ReelitPro looks on this device.",
      }),
      status: isDarkTheme(themeMode)
        ? t("dark_mode", { defaultValue: "Dark mode" })
        : t("light_mode", { defaultValue: "Light mode" }),
    },
    {
      page: SETTINGS_PAGES.PUSH,
      Icon: BellRing,
      title: t("settings_hub_push_title", { defaultValue: "Push notifications" }),
      description: t("settings_hub_push_description", {
        defaultValue: "Control notification delivery, categories and registered devices.",
      }),
      status: t(pushStatusKey, { defaultValue: pushStatusFallback }),
    },
  ];

  return (
    <nav className="rp-settings-hub" aria-label={t("settings_navigation_label", { defaultValue: "Settings sections" })}>
      {cards.map(({ page, Icon, title, description, status }) => (
        <button key={page} type="button" className="rp-settings-hub__card" onClick={() => onNavigate(page)}>
          <span className="rp-settings-hub__icon" aria-hidden="true"><Icon size={22} /></span>
          <span className="rp-settings-hub__copy"><strong>{title}</strong><span>{description}</span></span>
          <span className="rp-settings-hub__meta"><span>{status}</span><ChevronRight size={19} aria-hidden="true" /></span>
        </button>
      ))}
    </nav>
  );
}
